module.exports = __webpack_public_path__ + "static/media/02.b19479b0.png";